<template>
    <div>
        <h3>Scegli la quantità di piatti al giorno</h3>
            <p>Seleziona se avere solo un pasto al giorno o un menu completo</p>
        
            <div class="d-flex gap-3 my-6">
                <button v-for="(variation, i) in variations"
                    :key="i"
                    class="btn btn-lg btn-secondary" 
                    :class="{ 'active': variation.id === activeVariation}"
                    @click="selectVariation(variation.id)">
                    <span class="label" v-html="prepName(variation.name)"></span>
                </button>
            </div>

            <div class="d-flex justify-content-center justify-content-md-start">
                <button 
                        class="steplink stepback btn btn-secondary me-2"
                        @click="backStep" 
                        >Indietro</button>
                <button 
                    class="steplink stepnext btn btn-primary"
                    :disabled="canGoNext"
                    @click="nextStep" 
                    >Continua</button>
            </div>
    </div>
</template>

<script>
import {
    isEmpty,
    split,
    trim
} from "lodash";

export default {
    name: 'QuantityStep',
    data() {
        return {
            variations: this.$store.state.variations
        }
    },
    computed: {
        activeVariation() {
            return this.$store.state.abbonamento.variation;
        },
        canGoNext() {
            return !this.$store.state.abbonamento.variation;
        }
    },
    methods: {
        prepName(val) {
            const a = split(val, '-');
            const b = split(trim(a[1]), ' ');
            return b[1] + '<br>' + b[0];
        },
        backStep() {
            this.$emit("update", {
                back: true
            });
            return;
        },
        nextStep() {
            this.$emit("update", {
                next: true
            });
        },
        selectVariation(id){
            let va = this.variations.filter(variation => variation.id == id);
            if (!isEmpty(va)) {
                this.$store.commit("setStore", { variation: id });
                this.log(va[0]);
                
            }
        }
    },
    mounted() {
        this.GTM_trackView("Step quantity", "/abbonamento#step2");
    }
}
</script>